export const AUTH_CONFIG_LOCAL = {
    api_audience: 'api.easyscale.be',
    domain: 'easy-scale.eu.auth0.com',
    clientId: 'Dr5JNZISnfdRjE1onnPpQzTJ60T4n9Vy',
    callbackUrl: 'http://localhost:3006/callback',
    frontend: 'http://localhost:3006',
    connection: 'Username-Password-Authentication'
  }

  export const AUTH_CONFIG_DEV = {
    api_audience: 'api.easyscale.be',
    domain: 'easy-scale.eu.auth0.com',
    clientId: 'Dr5JNZISnfdRjE1onnPpQzTJ60T4n9Vy',
    callbackUrl: 'https://dev.easyscale.be/callback',
    frontend: 'https://dev.easyscale.be',
    connection: 'Username-Password-Authentication'
  }

  export const AUTH_CONFIG_PRODUCTION = {
    api_audience: 'api.easyscale.be',
    domain: 'easy-scale.eu.auth0.com',
    clientId: 'Dr5JNZISnfdRjE1onnPpQzTJ60T4n9Vy',
    callbackUrl: 'https://app.easyscale.be/callback',
    frontend: 'https://app.easyscale.be',
    connection: 'Username-Password-Authentication'
  }